var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E1F3E1",
    stroke: "#373A37",
    strokeWidth: 1.94
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.489 1.31c1.708.628 3.188 1.64 4.29 2.918 1.293 1.497 2.066 3.358 2.066 5.38 0 1.705-.55 3.296-1.496 4.65-1.11 1.586-2.763 2.847-4.726 3.598h0v9.174h-8.43l-.001-9.174c-1.963-.75-3.616-2.012-4.726-3.598C1.52 12.904.97 11.313.97 9.608c0-2.022.773-3.883 2.065-5.38 1.103-1.277 2.582-2.29 4.291-2.918h0v9.794h8.163z",
    transform: "translate(-24 -282) translate(0 56) translate(0 218) translate(24 8) translate(5 2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuConfiguration);
export default __webpack_public_path__ + "static/media/menu-configuration.00fb8428d96a00a9b1c0feaf0c963c82.svg";
export { ForwardRef as ReactComponent };